import { defineStore } from 'pinia';
import { ref } from 'vue';

export type AppToastType = 'success' | 'error' | 'info';

export interface AppToastItem {
  id: number;
  title: string;
  type: AppToastType;
  duration: number;
  leaving?: boolean;
}

let toastSeq = 1;

export const useToastStore = defineStore('appToast', () => {
  const items = ref<AppToastItem[]>([]);

  const push = (payload: {
    title: string;
    type?: AppToastType;
    duration?: number;
  }) => {
    const title = String(payload.title || '').trim();
    if (!title) return 0;

    // 系统通知体验：新提示替换仍在展示的旧条，避免连点堆叠
    const keepLeaving = items.value.filter((t) => t.leaving);
    items.value = keepLeaving;

    const id = toastSeq++;
    const duration = Math.max(1200, Number(payload.duration) || 2200);
    const item: AppToastItem = {
      id,
      title,
      type: payload.type || 'success',
      duration,
    };
    items.value = [...items.value, item].slice(-3);

    setTimeout(() => {
      dismiss(id);
    }, duration);

    return id;
  };

  const dismiss = (id: number) => {
    const hit = items.value.find((t) => t.id === id);
    if (!hit || hit.leaving) return;
    hit.leaving = true;
    items.value = [...items.value];
    setTimeout(() => {
      items.value = items.value.filter((t) => t.id !== id);
    }, 280);
  };

  const clear = () => {
    items.value = [];
  };

  return { items, push, dismiss, clear };
});
